import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";

export const ContentFaqGetApi = createApi({
  reducerPath: "ContentFaqGetApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  tagTypes: ["contentFaq"],
  endpoints: (builder) => ({
    getContentFaq: builder.mutation({
      query: (fileName: string) => {
        return {
          url: `/asset/json/${fileName}`,
          method: "POST"
        };
      },
      extraOptions: { service: "Utility" }
    })
  })
});

export const { useGetContentFaqMutation } = ContentFaqGetApi;
